<script lang="ts" setup>
import {SynchroDirection} from "@/domain/type/synchro.type.ts";
import FusionInput from "@/components/Fusion/FusionInput.vue";
import FusionInputSrc1 from "@/components/Fusion/FusionInputSrc1.vue";
import FusionInputSrc2 from "@/components/Fusion/FusionInputSrc2.vue";
import {RequestEntity, type SynchroRequestField} from "@/domain/type/synchro.api.type.ts";

defineProps<{
  request?: SynchroRequestField,
  entity: RequestEntity
}>()
const model = defineModel()

function getBgColor(request: SynchroRequestField) {
  if (undefined !== model.value) {
    return 'bg-success'
  }
  if (request.isDisallowed) {
    return 'bg-red'
  }

  if (request.isOptionnel) {
    return 'bg-fusion bg-success-striped'
  }

  return 'bg-fusion'
}

</script>

<template>
  <div v-if="request" class="fusionLine">
    <v-row
      :class="getBgColor(request)"
      class="pa-1 mb-02 mt-0 pt-0"
        no-gutters
      >
        <v-col class="pa-0 src1" cols="4">
          <fusion-input-src1 v-model="model" :entity="entity" :request="request"/>
        </v-col>
        <v-col class="pa-0 fusion" cols="4">
          <fusion-input :direction="model as SynchroDirection" :entity="entity" :request="request"/>
        </v-col>
        <v-col class="pa-0 src2" cols="4">
          <fusion-input-src2 v-model="model" :entity="entity" :request="request"/>
        </v-col>
      </v-row>
  </div>
</template>

<style scoped>
.bg-success-striped {
  background-color: green;
  background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
  background-repeat: initial;
  width: 100%;
}
</style>
